module.exports = __webpack_public_path__ + "img/Generaxion_OPN_Logo_Wordmark_white.24a4fedd.svg";